import React, { useEffect } from 'react';
import { arrayOf, bool, func, number, object, shape, string } from 'prop-types';
import classnames from 'classnames';
import Search from '../../../../Search/Search';
import { Toggle } from 'ps-design/';
import './GeoTableModifiers.scss';

GeoTableModifiers.propTypes = {
  groupByJobFamily: bool,
  hasData: bool,
  searchInputRef: object,
  setSearchText: func,
  showApplyGeo: bool,
  showCompanyLocations: bool,
  showGrouped: bool,
  showPayScaleLocations: bool,
  showUnmatchedOnly: bool,
  totalEmployees: number,
  toggleSubRows: func,
  toggledRows: arrayOf(number),
  toggleUnmatchedLocations: func
};

const COMPANY_PLACEHOLDER = 'Company Locations';
const EXPAND_ROWS_TEXT = 'Expand all rows';
const FAMILY_PLACEHOLDER = 'or Job Family';
const FAVORITE_PLACEHOLDER = 'Favorite Locations';
const FILTER_LABEL = 'Filter By';
const PAYSCALE_PLACEHOLDER = 'Search Location';
const UNMATCHED_ONLY_LABEL = 'Show unmatched locations only';

function GeoTableModifiers(props) {
  const {
    groupByJobFamily,
    hasData,
    searchInputRef,
    setSearchText,
    showApplyGeo,
    showCompanyLocations,
    showGrouped,
    showPayScaleLocations,
    showUnmatchedOnly,
    toggleSubRows,
    toggledRows,
    toggleUnmatchedLocations
  } = props;

  const showOnlySearch = !showPayScaleLocations || (showPayScaleLocations && hasData);

  useEffect(() => {
    return () => {
      setSearchText('');
    };
  }, []);

  function getSearchPlaceholderText() {
    const locationOnlyText = showPayScaleLocations
        ? PAYSCALE_PLACEHOLDER
        : showCompanyLocations
        ? COMPANY_PLACEHOLDER
        : FAVORITE_PLACEHOLDER,
      locationFamilyText = `${locationOnlyText} ${FAMILY_PLACEHOLDER}`;
    if (showPayScaleLocations) return locationOnlyText;
    return showGrouped && !showApplyGeo ? locationFamilyText : locationOnlyText;
  }

  function searchOnKeyDown(event) {
    if (event.key === 'Enter') {
      const searchValue = event.target.value;
      setSearchText(searchValue);
    }
  }

  function searchOnSearch() {
    const searchValue = searchInputRef?.current?.state?.searchValue;
    setSearchText(searchValue);
  }

  function searchOnClick() {
    setSearchText('');
  }

  return (
    <div className={classnames('data-adjustments__container', { 'company-locations__tab': showCompanyLocations })}>
      <div className={classnames('search__container', { 'payscale-locations__search': showPayScaleLocations })}>
        {!showApplyGeo && showCompanyLocations && <label className="locations-filter__label">{FILTER_LABEL}</label>}
        <Search
          onClick={searchOnClick}
          onKeyDown={searchOnKeyDown}
          onSearch={searchOnSearch}
          placeholder={getSearchPlaceholderText()}
          ref={searchInputRef}
          testId="geo-landing-page__search"
          useInternalState
        />
      </div>
      <div className="data-adjustments">
        {!showApplyGeo && showOnlySearch && showGrouped && (
          <div className="location-toggle__container">
            <Toggle
              className="location-toggle"
              id="location-toggle__details"
              onChange={e => toggleSubRows(e)}
              value={toggledRows.length === 0}
            />
            <span className="location-toggle__text">{EXPAND_ROWS_TEXT}</span>
          </div>
        )}
        {(showApplyGeo || showCompanyLocations) && ((showGrouped && groupByJobFamily) || !showGrouped) && (
          <div className="location-toggle__container">
            <Toggle
              className="location-toggle"
              id="unmatched-location__toggle"
              onChange={() => toggleUnmatchedLocations()}
              value={showUnmatchedOnly}
            />
            <span className="location-toggle__text">{UNMATCHED_ONLY_LABEL}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default GeoTableModifiers;
